import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  BEST_CHOICE_LABEL: `${cleanedFilename(__filename)}-best-choice`,
  CURRENT_CHOICE_LABEL: `${cleanedFilename(__filename)}-current-choice`,
  SELECT_BUTTON: `${cleanedFilename(__filename)}-select-button`,
};
